import classnames from 'classnames/bind'
import RecruiterDestinationClient from 'clients/user_notice/recruiter_destinations_client'
import Button from 'components/button'
import ButtonGroup from 'components/button_group'
import ListPagination from 'components/list_pagination'
import LoadingIndicator from 'components/loading_indicator'
import NoticeEmpty from 'components/notice_empty'
import TabGroup from 'components/tab_group'
import TabPanel from 'components/tab_panel'
import Pagination from 'entities/pagination'
import RecruiterDestination from 'entities/user_notice/recruiter_destination'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import Modal from 'react-overlays/lib/Modal'
import { setModalStyle } from 'supports/modal_style_helper'
import styles from './user_notice_content_history_destinations_modal.module.scss'

const cx = classnames.bind(styles)

const RecruiterDestinationList = ({ destinations, isFetching }) => {
  if (isFetching) {
    return <LoadingIndicator />
  }

  if (isEmpty(destinations)) {
    return (
      <NoticeEmpty className="notice-empty-with-modal">
        <i className="ic-info-outline" />
        {I18n.t('components.user_notice_content_history_destinations_modal.message.not_exist')}
      </NoticeEmpty>
    )
  }

  return (
    <div className="modal-scrollable-content">
      {destinations.map(destination => (
        <div className="recruiter-destination" key={destination.id}>
          <div className="recruiter-names">
            <span className="recruiter-name">{destination.name}</span>
            {destination.tags.map(tag => (
              <span className="recruiter-tag" key={tag.id}>
                {tag.name}
              </span>
            ))}
          </div>
          <div className="recruiter-info">
            {destination.group.name} / {destination.number}
          </div>
        </div>
      ))}
    </div>
  )
}

RecruiterDestinationList.propTypes = {
  destinations: PropTypes.arrayOf(PropTypes.instanceOf(RecruiterDestination)),
  isFetching: PropTypes.bool.isRequired
}

RecruiterDestinationList.defaultProps = {
  destinations: []
}

export default class UserNoticeContentHistoryDestinationsModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      contentId: props.content_id,
      isFetching: false,
      isOpened: false,
      revokedDestinations: null,
      revokedDestinationPagination: Pagination.initializeWithPage(1),
      selectedTabIndex: 0,
      sentDestinations: null,
      sentDestinationPagination: Pagination.initializeWithPage(1)
    }
  }

  async getSentDestinations(page = null) {
    const { contentId } = this.state

    this.setState({
      isFetching: true
    })

    try {
      const { destinations, pagination } = await RecruiterDestinationClient.getRecruiterDestinations(contentId, 1, page)
      this.setState(
        {
          isFetching: false,
          sentDestinations: destinations,
          sentDestinationPagination: pagination
        },
        () => setModalStyle(this.modal)
      )
    } catch (error) {
      this.setState({
        isFetching: false
      })
    }
  }

  async getRevokedDestinations(page = null) {
    const { contentId } = this.state

    this.setState({
      isFetching: true
    })

    try {
      const { destinations, pagination } = await RecruiterDestinationClient.getRecruiterDestinations(contentId, 3, page)
      this.setState(
        {
          isFetching: false,
          revokedDestinations: destinations,
          revokedDestinationPagination: pagination
        },
        () => setModalStyle(this.modal)
      )
    } catch (error) {
      this.setState({
        isFetching: false
      })
    }
  }

  show() {
    this.setState(
      {
        isOpened: true
      },
      () => {
        return Promise.resolve()
          .then(() => this.getSentDestinations())
          .then(() => this.getRevokedDestinations())
      }
    )
  }

  hide() {
    this.setState({
      isOpened: false,
      sentDestinations: null,
      revokedDestinations: null
    })
  }

  handleSwitchTabIndex(index) {
    this.setState(
      {
        selectedTabIndex: index
      },
      () => setModalStyle(this.modal)
    )
  }

  render() {
    const {
      isFetching,
      isOpened,
      selectedTabIndex,
      sentDestinations,
      sentDestinationPagination,
      revokedDestinations,
      revokedDestinationPagination
    } = this.state

    return (
      <Fragment>
        <button type="button" className="btn btn-default-primary" onClick={() => this.show()}>
          {I18n.t('components.user_notice_content_history_destinations_modal.button.destinations')}
        </button>
        <Modal show={isOpened} onShow={() => setModalStyle(this.modal)}>
          <div className="modal destination-modal">
            <div className="modal-bg" onClick={() => this.hide()} role="presentation" />
            <div
              className="modal-in"
              ref={ref => {
                this.modal = ref
              }}
            >
              <div className="modal-header">
                <div className="title">{I18n.t('components.user_notice_content_history_destinations_modal.title')}</div>
                <button type="button" className="btn btn-close" onClick={() => this.hide()}>
                  <i className="ic-close" />
                </button>
              </div>
              <div className="modal-body">
                <div className="destination-tab">
                  <ButtonGroup
                    className="destination-tab-btn-group"
                    selectedKey={selectedTabIndex}
                    onSwitch={index => this.handleSwitchTabIndex(index)}
                  >
                    <Button className="btn btn-destination">
                      {I18n.t('components.user_notice_content_history_destinations_modal.button.sent')}
                    </Button>
                    {isEmpty(revokedDestinations) ? null : (
                      <Button className="btn btn-destination">
                        {I18n.t('components.user_notice_content_history_destinations_modal.button.cancel')}
                      </Button>
                    )}
                  </ButtonGroup>
                  <TabGroup className="destination-tab-group" selectedIndex={selectedTabIndex}>
                    <TabPanel className="destination-tab-panel">
                      <RecruiterDestinationList destinations={sentDestinations} isFetching={isFetching} />
                      {isFetching ? null : (
                        <div className={cx(styles.listFooter)}>
                          <ListPagination
                            pagination={sentDestinationPagination}
                            onPageClick={page => this.getSentDestinations(page)}
                          />
                        </div>
                      )}
                    </TabPanel>
                    {isEmpty(revokedDestinations) ? null : (
                      <TabPanel className="destination-tab-panel">
                        <div className="destination-help-block state-danger">
                          {I18n.t('components.user_notice_content_history_destinations_modal.message.attention')}
                        </div>
                        <RecruiterDestinationList destinations={revokedDestinations} isFetching={isFetching} />
                        {isFetching ? null : (
                          <div className={cx(styles.listFooter)}>
                            <ListPagination
                              pagination={revokedDestinationPagination}
                              onPageClick={page => this.getRevokedDestinations(page)}
                            />
                          </div>
                        )}
                      </TabPanel>
                    )}
                  </TabGroup>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    )
  }
}

UserNoticeContentHistoryDestinationsModal.propTypes = {
  content_id: PropTypes.number.isRequired
}
